import { PRODUCT } from "@/constants";
import EcommerceItem from "@/types/gtm/EcommerceItem";
import { PolicyPackagePrice } from "@/types/PolicyPackagePriceType";
import { QuoteData } from "@/types/quote/quote-data";

function QuoteCoverTypeMap(
  attributes: QuoteData["attributes"]
): EcommerceItem[] {
  const brand = PRODUCT;

  const { tripDetails, priceResult } = attributes;

  const isInitialLoad = tripDetails?.initialQuotePageLoading;

  if (priceResult && tripDetails) {
    const { policyPackagePrice } = priceResult;

    if (policyPackagePrice.length === 0) return [];

    const policyType = tripDetails?.policyType;
    let policyItem: PolicyPackagePrice[] = [];
    if (isInitialLoad) {
      policyItem = policyPackagePrice.filter(
        (item) => item?.policyType === policyType
      );
    } else {
      policyItem = policyPackagePrice.filter(
        (item) =>
          item.policyType === policyType &&
          item.policyPackage === tripDetails.policyPackage
      );
    }

    if (policyItem.length) {
      const response: EcommerceItem[] = [];
      policyItem.forEach((item, i) => {
        response.push({
          item_id: `${item.policyType}_${item.policyPackage}`,
          item_name: item.policyPackage,
          coupon: null,
          index: i + 1,
          discount: 0,
          item_brand: `${brand[0].toUpperCase()}${brand.slice(1)}`, // make uppercase first letter
          item_category: item.policyType,
          item_category2: tripDetails?.goingOnCruise ? "cruise" : null,
          price: item.total,
          quantity: 1,
        });
      });
      return response;
    }

    return [];
  }
  return [];
}

export default QuoteCoverTypeMap;
